import { Clock, ShieldOff, Lock } from 'lucide-react'
import { AuthShell } from './AuthShell.js'
import { safeReturnTo } from '../shell/auth-routing.js'

/** /session-expired — la session a atteint sa limite (8 h d'inactivité ou 12 h). */
export function SessionExpiredPage() {
  // LOT 6 : le return_to (validé) voyage jusqu'au login — après reconnexion,
  // on revient là où la session s'est éteinte.
  const rt = safeReturnTo(new URLSearchParams(window.location.search).get('return_to'))
  const loginHref = rt ? `/login?return_to=${encodeURIComponent(rt)}` : '/login'
  return (
    <AuthShell title="Session expirée">
      <div className="lc-form">
        <span className="lc-auth__icon-lg lc-auth__icon-lg--warn" aria-hidden="true">
          <Clock size={30} />
        </span>
        <p className="lc-auth__body">
          Par sécurité, votre session s’est terminée automatiquement.
          Vos données sont intactes — reconnectez-vous pour reprendre.
        </p>
        <a className="lc-auth__cta" href={loginHref} style={{ textDecoration: 'none' }}>
          Se reconnecter
        </a>
      </div>
    </AuthShell>
  )
}

/** Origine non canonique (LOT 6, §102) — le portail ne s'utilise pas ici :
 *  on indique la bonne adresse, sans jargon et sans rien casser d'autre. */
export function SecureOriginPage(props: { origin: string | null }) {
  const target = props.origin ?? 'https://gestion.liveclubrennes.com'
  return (
    <AuthShell title="Connexion sécurisée requise">
      <div className="lc-form">
        <span className="lc-auth__icon-lg" aria-hidden="true">
          <Lock size={30} />
        </span>
        <p className="lc-auth__body">
          Gestion s’utilise désormais uniquement via son adresse sécurisée.
          Vos données et vos clés d’accès en dépendent.
        </p>
        <a className="lc-auth__cta" href={target} style={{ textDecoration: 'none' }}>
          Ouvrir {target.replace(/^https?:\/\//, '')}
        </a>
      </div>
    </AuthShell>
  )
}

/** /access-denied — connecté, mais sans le droit d'accéder à cette zone. */
export function AccessDeniedPage() {
  return (
    <AuthShell title="Accès refusé">
      <div className="lc-form">
        <span className="lc-auth__icon-lg lc-auth__icon-lg--deny" aria-hidden="true">
          <ShieldOff size={30} />
        </span>
        <p className="lc-auth__body">
          Votre compte n’a pas accès à cette zone du portail.
          Si vous pensez qu’il s’agit d’une erreur, rapprochez-vous de l’administrateur.
        </p>
        <a className="lc-auth__cta" href="/" style={{ textDecoration: 'none' }}>
          Revenir au tableau de bord
        </a>
      </div>
    </AuthShell>
  )
}
